//[ ACTIVE, INACTIVE, SCHEDULED, DRAFT, PAUSED, OUTDATED, SUSPENDED ]

import { StringUtil } from "../utils/string.util"

export const CampaignStateEnum = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    SCHEDULED: "SCHEDULED",
    DRAFT: "DRAFT",
    PAUSED: "PAUSED",
    OUTDATED: "OUTDATED",
    SUSPENDED: "SUSPENDED",
    CANCELED: "CANCELED",
    FINISHED: "FINISHED"
}

//Currently is not used cause it is DYNAMIC by StringUtil.formatStringFirstLetter
export const CampaignStateType = (type) => {
    return {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        SCHEDULED: 'Scheduled',
        DRAFT: 'Draft',
        PAUSED: 'Paused',
        SCHEDULED: 'Scheduled',
        OUTDATED: "Outdated",
        SUSPENDED: "Suspended",
        CANCELED: "Canceled",
        FINISHED: "Finished"
    }[type]
}


export const CampaignStateDisplayName = (type) => {
    return {
        ACTIVE: 'Running',
        INACTIVE: 'Inactive',
        SCHEDULED: 'Scheduled',
        DRAFT: 'Draft',
        PAUSED: 'Paused',
        SCHEDULED: 'Scheduled',
        OUTDATED: "Outdated",
        SUSPENDED: "Suspended",
        CANCELED: "Canceled",
        FINISHED: "Finished"
    }[type]
}

export const CampaignStateMethodEnum = {
    PAUSE: "pause",
    PUBLISH: "publish",
    RESUME: "resume",
    SUSPEND: "suspend",
    DELETE: "DELETE"
}

export const ImageTypeMethodEnum = {
    VOUCHER: "uploadVoucherImage",
    HERO: "uploadHeroImage"
}

export const CampaignScopeRadioEnum = {
    ALL: "ALL CUSTOMERS",
    CUSTOM: "CUSTOM SCOPES",
}

export const CampaignScopeEnum = {
    "ALL CUSTOMERS": "ALL CUSTOMERS",
    "REGULAR CUSTOMER": "REGULAR CUSTOMER",
    "NEW CUSTOMER": "NEW CUSTOMER",
    "SMARPAY WALLET CUSTOMER": "SMARPAY WALLET CUSTOMER",
}

export const CampaignScopeDisplayName = (type) => {
    return {
        [CampaignScopeEnum["ALL CUSTOMERS"]]: StringUtil.capitalizeFirstLetterInStringArray(CampaignScopeEnum["ALL CUSTOMERS"].split(" ")).join(" "),
        [CampaignScopeEnum["REGULAR CUSTOMER"]]: StringUtil.capitalizeFirstLetterInStringArray(CampaignScopeEnum["REGULAR CUSTOMER"].split(" ")).join(" "),
        [CampaignScopeEnum["NEW CUSTOMER"]]: StringUtil.capitalizeFirstLetterInStringArray(CampaignScopeEnum["NEW CUSTOMER"].split(" ")).join(" "),
        [CampaignScopeEnum["SMARPAY WALLET CUSTOMER"]]: StringUtil.capitalizeFirstLetterInStringArray(CampaignScopeEnum["SMARPAY WALLET CUSTOMER"].split(" ")).join(" "),
    }[type]
}

export const CampaignFieldsEnum = {
    id: "id",
    createdAt: "createdAt",
    createdBy: "createdBy",
    description: "description",
    endDate: "endDate",
    heroPromotionText: "heroPromotionText",
    merchantId: "merchantId",
    name: "name",
    products: "products",
    scopes: "scopes",
    startDate: "startDate",
    state: "state",
    updatedAt: "updatedAt",
    updatedBy: "updatedBy",
    voucherBenefits: "voucherBenefits",
    voucherIssueLimit: "voucherIssueLimit",
    voucherType: "voucherType",
    voucherValue: "voucherValue",
    issuedVouchers: "issuedVouchers",
    redeemedVouchers: "redeemedVouchers"
}
